import { PlaycastMessage, PlaycastMessageGamepadSetState, PlaycastMessageTarget, generators } from '@playcastdotio/Messaging';
import { ipcSend } from '../protocols/ipc';
import { getStateStore } from '../../stores';
import { handleIncomingGamepadMessage } from '../../modules/events/gamepadEvents';
import { notifyInput } from '../../modules/managers/playerActivity';

const store = getStateStore('ipc');

export const handleIncomingMessages = (remoteId: string, message: PlaycastMessage<PlaycastMessageTarget>) => {
  const hostReceiveTime = performance.now();

  const messageCreationTime = message.body.timings?.[0]?.timestamp || Date.now();
  const transitTime = hostReceiveTime - messageCreationTime;

  const messageWithTransitTiming = generators.addTiming(
    message,
    {
      timestamp: hostReceiveTime,
      description: 'transit_time_over_wire',
    },
    'host',
    {
      transit_time_ms: (Math.round(transitTime * 100) / 100).toString(),
      message_creation_time: messageCreationTime.toString(),
      host_receive_time: hostReceiveTime.toString(),
    },
  );

  // We want to verify the message source here to ensure that it is coming from the player.
  const source = messageWithTransitTiming.header.source;
  const target = messageWithTransitTiming.header.target;
  const isReply = messageWithTransitTiming.header.isReply;
  if (store.pauseInputState.currentState.players[remoteId]?.paused || store.pauseInputState.currentState.paused) {
    console.warn('[Player-Handler] Player input is paused');
    return;
  }
  if (source === 'player') {
    if (target === 'keyboard') {
      if (isReply) {
        console.warn('[Player-Handler] Invalid message received from player');
        return;
      }
      const keyboardAccess = store.playerState.currentState.players[remoteId]?.access.keyboard;
      if (!keyboardAccess) {
        console.error('[Player-Handler] Player does not have keyboard access');
        return;
      }
      notifyInput(remoteId, 'keyboard');
      ipcSend(messageWithTransitTiming);
    }
    if (target === 'mouse') {
      if (isReply) {
        console.warn('[Player-Handler] Invalid message received from player');
        return;
      }
      const mouseAccess = store.playerState.currentState.players[remoteId]?.access.mouse;
      if (!mouseAccess) {
        console.error('[Player-Handler] Player does not have mouse access');
        return;
      }
      notifyInput(remoteId, 'mouse');
      ipcSend(messageWithTransitTiming);
    }
    if (target === 'touch') {
      if (isReply) {
        console.warn('[Player-Handler] Invalid message received from player');
        return;
      }
      const touchAccess = store.playerState.currentState.players[remoteId]?.access.touch;
      if (!touchAccess) {
        console.error('[Player-Handler] Player does not have touch access');
        return;
      }
      notifyInput(remoteId, 'touch');
      ipcSend(messageWithTransitTiming);
    }
    if (target === 'gamepad') {
      if (isReply) {
        console.warn('[Player-Handler] Invalid message received from player');
        return;
      }
      if (message.header.action === 'setState') {
        const gamepadAccess = store.playerState.currentState.players[remoteId]?.access.gamepad;
        if (!gamepadAccess) {
          return console.error('[Gamepad] Player does not have gamepad access.', remoteId);
        }
        handleIncomingGamepadMessage(remoteId, messageWithTransitTiming as PlaycastMessage<PlaycastMessageGamepadSetState>);
      } else {
        ipcSend(messageWithTransitTiming);
      }
    }
  }
};
